import { useRef, useState } from "react";
import { NotificationManager as nm } from "react-notifications";

export const requestWithCallbacks = (api, options = {}) => new Promise((resolve, reject) => {
  api({ ...options, handleSuccess: resolve, handleError: reject });
});

export default function usePendingAction() {
  const [isPending, setIsPending] = useState(false);
  const pending = useRef(false);

  const run = async (action) => {
    if (pending.current) return;
    pending.current = true;
    setIsPending(true);
    try {
      await action();
    } catch (error) {
      console.error("Could not finish the action", error);
      nm.warning("Could not finish the action. Check the latest data before trying again.");
    } finally {
      pending.current = false;
      setIsPending(false);
    }
  };

  return { isPending, run };
}
